import React from 'react';
import { withFormik, Field, FormikProps } from 'formik';
import { InputField } from '@/components/formFields/InputField';
import * as Yup from 'yup';
import { apiService } from '../../utils/api';
import { toast } from 'sonner';
import history from '../../history';
import { passwordValidation, passwordConfirmValidation } from '../../utils/passwordValidation';
import { getFieldErrors } from '../../utils/apiError';
import { Button } from '@/components/ui/Button';

const ValidationSchema = Yup.object().shape({
  username: Yup.string()
    .matches(/^[a-z0-9]+$/, 'Uživatelské jméno může obsahovat pouze malá písmena a čísla.')
    .required('Uživatelské jméno je povinné pole.'),
  email: Yup.string().email('Zadejte validní e-mail!').required('Povinné pole'),
  password: passwordValidation,
  password2: passwordConfirmValidation(Yup.ref('password')),
  first_name: Yup.string().required('Povinné pole'),
  last_name: Yup.string().required('Povinné pole'),
});

interface RegistrationFormValues {
  username: string;
  email: string;
  password: string;
  password2: string;
  degree_before: string;
  first_name: string;
  last_name: string;
  degree_after: string;
}

interface RegistrationFormOuterProps {
  onSubmit?: (values: Record<string, any>) => void;
  onClose?: () => void;
  error?: Record<string, string>;
}

type RegistrationFormInnerProps = FormikProps<RegistrationFormValues> & RegistrationFormOuterProps;

class C extends React.Component<RegistrationFormInnerProps> {
  state = {
    value: [],
  };

  componentDidUpdate(prevProps: RegistrationFormInnerProps) {
    if (prevProps.error !== this.props.error) {
      for (const _key in this.props.error) {
        this.props.setErrors(this.props.error);
      }
    }
  }

  render() {
    const { handleSubmit, values } = this.props;

    return (
      <div className="">
        <form onSubmit={handleSubmit} autoComplete="off" data-testid="registration-form">
          <div className="space-y-1">
            <div className="h-[30px] pb-2.5 text-neutral-600">
              <span>Údaje pro přihlášení</span>
            </div>
            <Field
              name="username"
              value={values.username}
              placeholder="Uživatelské jméno"
              component={InputField}
              data-testid="registration-username-input"
            />

            <Field
              name="email"
              value={values.email}
              placeholder="E-mail"
              component={InputField}
              data-testid="registration-email-input"
            />

            <Field
              name="password"
              type="password"
              value={values.password}
              placeholder="Heslo"
              component={InputField}
              data-testid="registration-password-input"
            />

            <Field
              type="password"
              name="password2"
              value={values.password2}
              placeholder="Potvrzovací heslo"
              component={InputField}
              data-testid="registration-password-confirm-input"
            />
            <div className="h-[30px] pb-2.5 text-neutral-600">
              <span>Údaje o uživateli</span>
            </div>
            <Field
              name="degree_before"
              value={values.degree_before}
              placeholder="Titul před jménem"
              component={InputField}
              data-testid="registration-degree-before-input"
            />
            <Field
              name="first_name"
              value={values.first_name}
              placeholder="Křestní jméno"
              component={InputField}
              data-testid="registration-first-name-input"
            />
            <Field
              name="last_name"
              value={values.last_name}
              placeholder="Příjmení"
              component={InputField}
              data-testid="registration-last-name-input"
            />
            <Field
              name="degree_after"
              value={values.degree_after}
              placeholder="Titul za jménem"
              component={InputField}
              data-testid="registration-degree-after-input"
            />

            <div className="flex justify-end gap-2 pt-2">
              <Button
                data-testid="registration-close-btn"
                type="button"
                variant="outline"
                onClick={() => history.go('/login' as any)}
              >
                Zavřít
              </Button>
              <Button data-testid="registration-submit-btn" type="submit">
                Založit nový účet
              </Button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const RegistrationForm = withFormik<RegistrationFormOuterProps, RegistrationFormValues>({
  enableReinitialize: true,
  validationSchema: ValidationSchema,
  validateOnBlur: false,
  mapPropsToValues: () => ({
    username: '',
    email: '',
    password: '',
    password2: '',
    degree_before: '',
    first_name: '',
    last_name: '',
    degree_after: '',
  }),
  handleSubmit: async (values, { setErrors }) => {
    try {
      delete apiService.defaults.headers.common.Authorization;
      await apiService.post('/my-rest-auth/register/', values);

      history.push('/registration');
      toast.success('success', { description: 'Verifikační e-mail odeslán.' });
    } catch (e: any) {
      setErrors(getFieldErrors(e));
    }
  },
})(C);

export default RegistrationForm;
